import { toast } from 'react-toastify';
import { useContext, useMemo } from 'react';
import { AppContext } from '../../../Context/AppContext';
import { TOOLTIP_MESSAGE } from '../../../Constants/Constants';
import { TReloadButtonProps } from './ReloadButton.type';
import './ReloadButton.scss';

const ReloadButton = (props: TReloadButtonProps) => {
  const {
    isExpandedCard,
    isRecentlyDelivered = false,
    handleClick = () => toast(TOOLTIP_MESSAGE),
  } = props;
  const { isMobile } = useContext(AppContext);
  const isMobileRoutes = isMobile ? 'Similar Routes ...' : 'Similar Routes Available';
  const similarRoutes =
    isExpandedCard === null || !isExpandedCard ? 'Similar Routes Available' : isMobileRoutes;
  const buttonName = useMemo(
    () => (isRecentlyDelivered ? similarRoutes : 'Reload'),
    [isRecentlyDelivered, isExpandedCard],
  );
  return (
    <div className="ReloadButton" onClick={handleClick}>
      <img src={'/oo/assets/icon/reload_icon.svg'} alt={`Reload_Icon`} className="Reload_Icon" />
      <span className="Reload_Label">{buttonName}</span>
    </div>
  );
};

export default ReloadButton;
